import { Component } from '@angular/core';

@Component({
  selector: 'abc-qrcode-overlay',
  template: `<div class="qr-code-overlay">
    <div class="edge-row-upper">
      <div class="edge-row-horizontal">
        <span class="horizontal-line"></span>
        <span class="horizontal-line"></span>
      </div>
      <div class="edge-row-vertical">
        <span class="vertical-line"></span>
        <span class="vertical-line"></span>
      </div>
    </div>
    <div class="edge-row-lower">
      <div class="edge-row-vertical">
        <span class="vertical-line"></span>
        <span class="vertical-line"></span>
      </div>
      <div class="edge-row-horizontal">
        <span class="horizontal-line"></span>
        <span class="horizontal-line"></span>
      </div>
    </div>
  </div>`,
  styleUrls: ['./abc-qrcode-overlay.component.scss'],
  standalone: false,
})
export class AbcQrCodeOverlayComponent {}
